import { Injectable, inject } from '@angular/core';
import { ApiService } from './api.service';

@Injectable({ providedIn: 'root' })
export class BalanceService {
  private api = inject(ApiService);

  updateSettlement(json: any) { return this.api.post('/settlement', json); }
  updateSettlementPayDate(json: any) { return this.api.post('/settlement/pay_date', json); }
  upsert(json: any) { return this.api.post('/balance', json); }
  remove(id: number) { return this.api.get(`/balance/remove/${id}`); }
  getDetail(id: number, periodMonth: string) { return this.api.get(`/balance/detail/${id}/${periodMonth}`); }
  getWithoutAggregation(settlementId: number, method: string, chargeType: string, type: string, subtype: string) {
    return this.api.get(`/balance/${settlementId}/${method}/${chargeType}/${type}/${subtype}`);
  }
}
